import { render, staticRenderFns } from "./TemporaryItemsSearch.vue?vue&type=template&id=3af863c8&scoped=true"
import script from "./TemporaryItemsSearch.vue?vue&type=script&lang=js"
export * from "./TemporaryItemsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af863c8",
  null
  
)

export default component.exports